// Import using the TypeScript definitions
import { AuthServicePromiseClient } from '../generated/fitness-service/v1/auth_grpc_web_pb';
import { AgencyServicePromiseClient } from '../generated/fitness-service/v1/agency_grpc_web_pb';
import { TrainerServicePromiseClient } from '../generated/fitness-service/v1/trainer_grpc_web_pb';
import { UserServicePromiseClient } from '../generated/fitness-service/v1/user_grpc_web_pb';
import { WorkoutServicePromiseClient } from '../generated/fitness-service/v1/workout_grpc_web_pb';
import { ExerciseServicePromiseClient } from '../generated/fitness-service/v1/exercise_grpc_web_pb';
import { AdminServicePromiseClient } from '../generated/fitness-service/v1/admin_grpc_web_pb';

// gRPC client configuration - Force HTTPS to avoid mixed content errors
const GRPC_HOST = process.env.REACT_APP_GRPC_HOST || 'https://trackhq.speeir.com/api';

// const GRPC_HOST = process.env.REACT_APP_GRPC_HOST || 'http://127.0.0.1:50052';

// Create client instances
let authServicePromiseClient: AuthServicePromiseClient | null = null;
let agencyServicePromiseClient: AgencyServicePromiseClient | null = null;
let trainerServicePromiseClient: TrainerServicePromiseClient | null = null;
let userServicePromiseClient: UserServicePromiseClient | null = null;
let workoutServicePromiseClient: WorkoutServicePromiseClient | null = null;
let exerciseServicePromiseClient: ExerciseServicePromiseClient | null = null;
let adminServicePromiseClient: AdminServicePromiseClient | null = null;

export function getAuthServicePromiseClient(): AuthServicePromiseClient {
    if (!authServicePromiseClient) {
        authServicePromiseClient = new AuthServicePromiseClient(GRPC_HOST);
    }
    return authServicePromiseClient;
}

export function getAgencyServicePromiseClient(): AgencyServicePromiseClient {
    if (!agencyServicePromiseClient) {
        agencyServicePromiseClient = new AgencyServicePromiseClient(GRPC_HOST);
    }
    return agencyServicePromiseClient;
}

export function getTrainerServicePromiseClient(): TrainerServicePromiseClient {
    if (!trainerServicePromiseClient) {
        trainerServicePromiseClient = new TrainerServicePromiseClient(GRPC_HOST);
    }
    return trainerServicePromiseClient;
}

export function getUserServicePromiseClient(): UserServicePromiseClient {
    if (!userServicePromiseClient) {
        userServicePromiseClient = new UserServicePromiseClient(GRPC_HOST);
    }
    return userServicePromiseClient;
}

export function getWorkoutServicePromiseClient(): WorkoutServicePromiseClient {
    if (!workoutServicePromiseClient) {
        workoutServicePromiseClient = new WorkoutServicePromiseClient(GRPC_HOST);
    }
    return workoutServicePromiseClient;
}

export function getExerciseServicePromiseClient(): ExerciseServicePromiseClient {
    if (!exerciseServicePromiseClient) {
        exerciseServicePromiseClient = new ExerciseServicePromiseClient(GRPC_HOST);
    }
    return exerciseServicePromiseClient;
}

export function getAdminServicePromiseClient(): AdminServicePromiseClient {
    if (!adminServicePromiseClient) {
        adminServicePromiseClient = new AdminServicePromiseClient(GRPC_HOST);
    }
    return adminServicePromiseClient;
}
